export class VersionControlInfo {
    /**
     * 版本字段标志
     */
    VersionControlElementId: string;
}
